import { css } from '@emotion/react'
import { colors, Tab } from 'plume-ui'
import { APPBAR_HEIGHT } from '../../header/AppBar'
import {
  Article,
  PeopleGlobalSearchResult,
  SearchResult,
  SearchTabType,
} from '../../../types'

export const searchTabs: SearchTabType[] = [
  'スタートアップ',
  '投資家',
  'オリジナル記事',
  'ファンド',
  '人物',
  'ベンチャー支援',
]

type Props = {
  activeTab: SearchTabType | null
} & { articles: Article[]; people: PeopleGlobalSearchResult } & SearchResult

export const SearchTabMenu: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        height: 56px;
        padding: 12px 0;
        background-color: ${colors.white00};
        margin: 0 auto;
        position: sticky;
        z-index: 10;
        border-top: 1px solid ${colors.borderLight};
        border-bottom: 1px solid ${colors.borderLight};
        top: calc(${APPBAR_HEIGHT} - 1px);
      `}
    >
      <div
        css={css`
          margin: 0 auto;
          display: flex;
          justify-content: center;
        `}
      >
        <Tab.Group
          css={css`
            min-width: 1150px;
          `}
        >
          {searchTabs.map((tab, i) => (
            <Tab
              key={i}
              active={tab === props.activeTab}
              as="a"
              href={`#${tab}`}
              count={countOfTab(tab, props)}
            >
              {tab}
            </Tab>
          ))}
        </Tab.Group>
      </div>
    </div>
  )
}

const countOfTab = (
  tabType: SearchTabType,
  result: SearchResult & {
    articles: Article[]
    people: PeopleGlobalSearchResult
  }
): number | undefined => {
  switch (tabType) {
    case 'スタートアップ':
      return result.companies.count
    case '投資家':
      return result.investors.count
    case 'オリジナル記事':
      return result.articles.length
    case 'ファンド':
      return result.funds.count
    case '人物':
      return result.people.count
    case 'ベンチャー支援':
      return result.ventureSupports.count
    default:
      return undefined
  }
}
